import React, { useEffect } from 'react';
import { Progress } from 'web-library';
import AnnouncementNoticeBoard from '../../../modules/announcement/components/AnnouncementNoticeBoard';
import { usePostSearchAnnouncements } from '../../../api-refactored/announcements/usePostSearchAnnouncements';
import { useGetAnnouncementConfig } from '../../../api-refactored/announcements-configuration/useGetAnnouncementConfig';

const ANNOUNCEMENT_TYPE = 'ANNOUNCEMENTS';

const NoticeBoard = () => {
  const {
    data: announcementDetailPage,
    mutate: postSearchAnnouncements,
  } = usePostSearchAnnouncements();

  const { data: announcementConfig } = useGetAnnouncementConfig({
    announcementType: ANNOUNCEMENT_TYPE,
  });

  useEffect(() => {
    postSearchAnnouncements({
      apiPathParam: {
        page: 0,
        pageSize: 3,
      },
      announcementType: ANNOUNCEMENT_TYPE,
      q: '',
    });
  }, [postSearchAnnouncements]);

  if (!announcementDetailPage || !announcementConfig) {
    return <Progress color="secondary" />;
  }

  return (
    <AnnouncementNoticeBoard
      announcementDetailPage={announcementDetailPage}
      announcementConfig={announcementConfig}
    />
  );
};

export default NoticeBoard;
